<span *ngIf="companyRoleKeys$ | async as companyRoleKeys">{{ companyRoleKeys }}</span>
